import { useState } from "react";
import { maskAccountNumber } from "../utils/maskAccountNumber";
import { useCopyToClipboard } from "../hooks/useCopyToClipboard";
import { ICON_BASE_PATH } from "./config";

type Props = {
  accountNumber: string;
  label?: string;
  visibleDigits?: number;
  hideEye?: boolean;
  ifCopy?: boolean;
};

export const MaskedAccountField = ({
  accountNumber = "",
  label,
  visibleDigits = 4, // Default to 4 digits
  hideEye = false,
  ifCopy = false,
}: Props) => {
  const [show, setShow] = useState(false);
  const { copied, copy } = useCopyToClipboard(accountNumber);

  const handleCopy = () => {
    if (accountNumber) {
      copy();
    }
  };

  const showHide = (e:any) => {
    e?.stopPropagation();
    setShow(!show);
  };

  return (
    <div className="gx-row gx-account-field">
      <span className="gx-t-lable">{label}</span>
      <div className="gx-account-value">
        <span className="gx-rtp-value gx-p12-b">
          {show
            ? accountNumber
            : maskAccountNumber(accountNumber, visibleDigits)}
        </span>
        {hideEye !== true && (
          <button onClick={showHide}>
            <img
              src={
                show
                  ? `${ICON_BASE_PATH}eyeopen.svg`
                  : `${ICON_BASE_PATH}eyeclose.svg`
              }
              alt="toggle"
              className="gx-icon-d"
            />
          </button>
        )}
        {ifCopy && (
          <>
            {copied ? (
              <div className="gx-copied-label">
                <img
                  src={`${ICON_BASE_PATH}copied-black.svg`}
                  alt="copied"
                  className="gx-icon-d"
                />
                {/* <p style={{ color: "green", fontSize: "12px" }}>Copied!</p> */}
              </div>
            ) : (
              <button onClick={handleCopy}>
                <img
                  src={`${ICON_BASE_PATH}copy-icon.svg`}
                  alt="copy"
                  className="gx-icon-d"
                />
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};
